import { ExpertProfileSkillValidatedDataRespType } from './api.types'

export enum LifeCycleStageColor {
    green = 'green',
    gold = 'gold',
    cloud = 'cloud',
    steel = 'steel',
}

export enum FiltersKey {
    NameAndEmail = 'Name/Email ID',
    ExpertiseArea = 'Expertise area',
    Languages = 'Languages',
    LifeCycleStage = 'Lifecycle stage',
    Location = 'Location',
    EducationDegree = 'Education degree',
    EducationMajor = 'Education major',
    Occupation = 'Occupation',
    YearsOfExperience = 'Years of experience',
}

export enum FiltersValue {
    NameAndEmail = 'nameAndEmail',
    ExpertiseArea = 'expertiseArea',
    Language = 'language',
    LifeCycleStage = 'lifeCycleStage',
    Location = 'location',
    EducationDegree = 'educationDegree',
    EducationMajor = 'educationMajor',
    Occupation = 'occupation',
    YearsOfExperience = 'yearsOfExperience',
}

export enum SkillType {
    Level = 'Level',
    Score = 'Score',
    ValidatonSource = 'Validation Source',
}

export enum SkillLabelType {
    Level = 'Level',
    Score = 'Score',
    ValidatonSource = 'Validation_Source',
}

export enum FiltersKeyType {
    SelectAll = 'Select ALL',
}

export enum TagType {
    skill = 'skill',
    skills = 'skills',
}

export type OptionType = { id?: string; label: string; value: string }

export type FilterOptionRespType = {
    occupation: OptionType[]
    educationDegree: OptionType[]
    educationMajor: OptionType[]
    location: OptionType[]
    language: OptionType[]
    lifeCycleStage: OptionType[]
}

export type ButtonConfig = {
    title: string
    key: string
    icon: string
    shouldDisplay: boolean
    onClick: () => void
}

export const FiltersLabelMapping: Record<string, string> = {
    lifeCycleStage: FiltersKey.LifeCycleStage,
    educationDegree: FiltersKey.EducationDegree,
    educationMajor: FiltersKey.EducationMajor,
    location: FiltersKey.Location,
    language: FiltersKey.Languages,
    occupation: FiltersKey.Occupation,
    expertiseArea: FiltersKey.ExpertiseArea,
    nameAndEmail: FiltersKey.NameAndEmail,
    yearsOfExperience: FiltersKey.YearsOfExperience,
}

export const LifeCycleStageColorMapping: Record<string, LifeCycleStageColor | undefined> = {
    Unoccupied: LifeCycleStageColor.green,
    'Occupied available': LifeCycleStageColor.gold,
    'Occupied unavailable': undefined,
    'Incomplete profile': LifeCycleStageColor.steel,
}

export type FilteredValueType = {
    level?: string[]
    skillIsValidatedBasedOn?: string
    score?: [number, number]
    isFilterApplied?: boolean
}

export type SkillsTableDataType = {
    key: React.Key
    skill: string
    level: string
    score?: number | boolean | string
    skillValidatedBy: string
    validationLog: ExpertProfileSkillValidatedDataRespType[]
}

export type EducationType = {
    degree: string
    major: string
}

export type PaginationType = {
    page: number
    pageSize: number
}
